import { useQuery } from "@apollo/client";
import { SystemTabInfo } from "../../graphql/queries/systemTabInfo";
import _ from "lodash";
import { CircularProgress, Typography } from "@mui/joy";
import { CloseRounded } from "@mui-symbols-material/w300";
import { useTranslation } from "react-i18next";

interface Props {
    systemId: string;
    activeTab?: boolean;
    onCloseTab?: (systemId: string) => void;
}

const SystemTabTitle = ({ systemId, activeTab, onCloseTab }: Props) => {
    const { t } = useTranslation();

    const systemTabInfoQuery = useQuery(SystemTabInfo, {
        variables: {
            id: systemId,
        },
    });

    const handleTabClose = (e: any, systemId: string) => {
        e.stopPropagation();
        if (onCloseTab) onCloseTab(systemId);
    };

    let label = <CircularProgress size="sm" />;

    if (!systemTabInfoQuery.loading) {
        // Node title is the editable one; system.title is fallback only (backend sync pending).
        const title = _.get(systemTabInfoQuery, "data.system.installedBaseNode.title")
            || _.get(systemTabInfoQuery, "data.system.title")
            || t("N/A");

        label = (
            <Typography
                noWrap
                sx={{ maxWidth: 280 }}
                fontWeight={activeTab ? "bold" : "normal"}
                level={"body-md"}
            >
                {title}
            </Typography>
        );
    }

    if (onCloseTab) {
        label = (
            <div className={"flex-row flex-align-items-center"}>
                {label}
                <CloseRounded
                    sx={{ color: "#666", marginLeft: "8px", fontSize: "16px", fontWeight: "normal" }}
                    onClick={(event) => handleTabClose(event, systemId)}
                />
            </div>
        );
    }

    return label;
};

export default SystemTabTitle;
